// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-152ccb07] {\n  width: calc(100% + var(--magic-space--large, 32px));\n  margin: calc(var(--magic-space, 16px) * -1);\n  margin-bottom: var(--magic-space--small, 8px);\n}", ""]);
// Exports
module.exports = exports;
